import apiClient from './api';

export const conversationsService = {
  getAll: async () => {
    const res = await apiClient.get('/Conversations');
    return res.data;
  },
  create: async (payload) => {
    const res = await apiClient.post('/Conversations', payload);
    return res.data;
  },
  getById: async (id) => {
    const res = await apiClient.get(`/Conversations/${id}`);
    return res.data;
  },
  update: async (id, payload) => {
    const res = await apiClient.put(`/Conversations/${id}`, payload);
    return res.data;
  },
  remove: async (id) => {
    const res = await apiClient.delete(`/Conversations/${id}`);
    return res.data;
  },
  getByUser: async (userId) => {
    const res = await apiClient.get(`/Conversations/user/${userId}`);
    return res.data;
  },
  getByType: async (conversationType) => {
    const res = await apiClient.get(`/Conversations/type/${conversationType}`);
    return res.data;
  },
  getByStatus: async (status) => {
    const res = await apiClient.get(`/Conversations/status/${status}`);
    return res.data;
  },
  getUserWithLatestMessage: async (userId) => {
    const res = await apiClient.get(`/Conversations/user/${userId}/with-latest-message`);
    return res.data;
  },
  updateStatus: async (id, status) => {
    const res = await apiClient.put(`/Conversations/${id}/status`, { status });
    return res.data;
  },
  assignProfessional: async (id, professionalId) => {
    const res = await apiClient.put(`/Conversations/${id}/assign-professional`, { professionalId });
    return res.data;
  },
  checkAccess: async (id, userId) => {
    const res = await apiClient.get(`/Conversations/${id}/access/${userId}`);
    return res.data;
  }
  ,
  addMember: async (conversationId, payload) => {
    // payload should be { userId } or { username }
    const res = await apiClient.post(`/Conversations/${conversationId}/members`, payload);
    return res.data;
  }
  ,
  // Find existing one-to-one conversation for the caller with otherUserId
  findOneToOne: async (otherUserId) => {
    const res = await apiClient.get(`/Conversations/one-to-one/${otherUserId}`);
    return res.data;
  },

  // Create-or-return a 1:1 conversation (atomic)
  ensureOneToOne: async (payload) => {
    // payload example: { otherUserId: 'guid' }
    // Try to use an atomic endpoint if available: POST /Conversations/one-to-one
    const otherUserId = payload?.otherUserId;
    if (!otherUserId) throw new Error('otherUserId required');

    const currentUser = JSON.parse(localStorage.getItem('user') || 'null');
    const clientId = currentUser?.id;


    // 1) Try GET lookup for existing 1:1 conversation (some servers implement GET /one-to-one/{otherUserId}).
    try {
      const found = await apiClient.get(`/Conversations/one-to-one/${otherUserId}`);
      if (found?.data) return found.data;
    } catch (err) {
      // ignore and continue to POST fallback below
    }

    // 2) Try atomic POST /Conversations/one-to-one when supported by backend.
    try {
      const atomicBody = { otherUserId };
      if (clientId) atomicBody.ClientId = clientId;
      const postRes = await apiClient.post(`/Conversations/one-to-one`, atomicBody);
      if (postRes?.data) return postRes.data;
    } catch (err) {
      // If the server returns 500/405/etc, swallow and fall back to create below.
    }

    // 3) Final fallback: create a new conversation via the standard create endpoint.
    const participants = payload?.participants || [otherUserId];
    const body = { participants };
    if (clientId) body.ClientId = clientId;
    const res = await apiClient.post(`/Conversations`, body);
    return res.data;
  },

  // List members
  getMembers: async (conversationId) => {
    const res = await apiClient.get(`/Conversations/${conversationId}/members`);
    return res.data;
  },

  // Remove member
  removeMember: async (conversationId, userId) => {
    const res = await apiClient.delete(`/Conversations/${conversationId}/members/${userId}`);
    return res.data;
  }
};
